import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { scheduledWorkflowRunsApi } from '@/lib/api/scheduled-workflow-runs.api';

import type { ScheduledWorkflowRunQuery } from '@repo/shared-types';

const QUERY_KEY = ['scheduled-workflow-runs'];

export const useScheduledWorkflowRuns = (query: Partial<ScheduledWorkflowRunQuery> = {}) =>
  useQuery({
    queryKey: [...QUERY_KEY, query],
    queryFn: () => scheduledWorkflowRunsApi.getAll(query),
    refetchInterval: 30_000,
  });

export const useCancelScheduledWorkflowRun = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => scheduledWorkflowRunsApi.cancel(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: QUERY_KEY }),
  });
};
